import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
};

const loadingSlice = createSlice({
    name: 'loading',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.loading = true;
        },
        finishLoading: (state) => {
            state.loading = false;
        },
    },
});

export const { startLoading, finishLoading } = loadingSlice.actions;
export default loadingSlice.reducer;